import { NotificationListFiltersTeamsChatDto } from '@dto/notification-list/notification-list-filters-teams-chat.dto';
import { NotificationListFiltersTeamsChannelDto } from '@dto/notification-list/notification-list-filters-teams-channel.dto';
import { NotificationListFiltersTeamsCampaignDto } from '@dto/notification-list/notification-list-filters-teams-campaign.dto';
import { NotificationListDto } from '@dto/notification-list/notification-list.dto';
import { createAction, props } from '@ngrx/store';

const state = '[Notification List Teams]';

// ─── Active tab ───────────────────────────────────────────────────────────────

export const setActiveTab = createAction(
  `${state} Set active tab`,
  props<{ tab: 'conversations' | 'channels' | 'campaigns' }>()
);

export const initActiveTab = createAction(
  `${state} Init active tab`,
  props<{ tab: 'conversations' | 'channels' | 'campaigns' }>()
);

// ─── Chats ────────────────────────────────────────────────────────────────────

export const loadNotificationListTeamsChats = createAction(
  `${state} Load chats`,
  props<{
    currentPageNumber: number;
    filters: NotificationListFiltersTeamsChatDto;
    pageSize: number;
  }>()
);

export const loadNotificationListTeamsChatsSuccess = createAction(
  `${state} Load chats Success`,
  props<{ notificationList: NotificationListDto }>()
);

export const loadNotificationListTeamsChatsFailure = createAction(
  `${state} Load chats Failure`,
  props<{ error: string }>()
);

// ─── Channels ─────────────────────────────────────────────────────────────────

export const loadNotificationListTeamsChannels = createAction(
  `${state} Load channels`,
  props<{
    currentPageNumber: number;
    filters: NotificationListFiltersTeamsChannelDto;
    pageSize: number;
  }>()
);

export const loadNotificationListTeamsChannelsSuccess = createAction(
  `${state} Load channels Success`,
  props<{ notificationList: NotificationListDto }>()
);

export const loadNotificationListTeamsChannelsFailure = createAction(
  `${state} Load channels Failure`,
  props<{ error: string }>()
);

// ─── Campaigns ────────────────────────────────────────────────────────────────

export const loadNotificationListTeamsCampaigns = createAction(
  `${state} Load campaigns`,
  props<{
    currentPageNumber: number;
    filters: NotificationListFiltersTeamsCampaignDto;
    pageSize: number;
  }>()
);

export const loadNotificationListTeamsCampaignsSuccess = createAction(
  `${state} Load campaigns Success`,
  props<{ notificationList: NotificationListDto }>()
);

export const loadNotificationListTeamsCampaignsFailure = createAction(
  `${state} Load campaigns Failure`,
  props<{ error: string }>()
);
